import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL + "/"
});

export const courseAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_COURSES_URL
});

export default axiosInstance;
